import {Rule} from "./types";

export const isRuleSubmitValid = (editingRule: Rule | null) => {
  if (!editingRule) return false;
  if (editingRule.priority == null) return false;
  if (!Array.isArray(editingRule.match?.keywords) || editingRule.match.keywords.length === 0) return false;
  if (!Array.isArray(editingRule.responses) || editingRule.responses.length === 0) return false;
  return true;
};
